import React from 'react';
import { Link } from 'react-router-dom';
import { TwitterIcon, LinkedinIcon, FacebookIcon, YoutubeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-au-green-dark text-white" data-id="element-203" data-mp="am5jyg5yhg3w">
      <div className="h-1 bg-au-gold" data-id="element-204" data-mp="akuembwv40ao"></div>
      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-205" data-mp="5n2qlszc8ybr">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-206" data-mp="5mau8fxx2wkf">
          <div data-id="element-207" data-mp="p1756y02wzr">
            <h3 className="font-bold text-lg mb-4" data-id="element-208" data-mp="pkejtq0y2zj">About</h3>
            <ul className="space-y-2" data-id="element-209" data-mp="3s25bma8ijfgy">
              <li data-id="element-210" data-mp="3s14064nl4qyp">
                <Link to="/about" className="hover:text-au-gold transition-colors" data-id="element-211" data-mp="3s0khglq41yjm">
                  About Us
                </Link>
              </li>
              <li data-id="element-212" data-mp="3j05sncdxu1bd">
                <Link to="/about" className="hover:text-au-gold transition-colors" data-id="element-213" data-mp="3e2mfygww1wlj">
                  Leadership
                </Link>
              </li>
              <li data-id="element-214" data-mp="2kdcxifenobkc">
                <Link to="/about" className="hover:text-au-gold transition-colors" data-id="element-215" data-mp="2kc1xmqobznyi">
                  Mandate
                </Link>
              </li>
              <li data-id="element-216" data-mp="2bdhj81pt00g3">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-217" data-mp="2bdzqdte07z2s">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-218" data-mp="3425bih8yzq35">
            <h3 className="font-bold text-lg mb-4" data-id="element-219" data-mp="342ez5y6jll5o">Procurement</h3>
            <ul className="space-y-2" data-id="element-220" data-mp="3837bj0apo666">
              <li data-id="element-221" data-mp="3825ri6bpw9cb">
                <Link to="/bids" className="hover:text-au-gold transition-colors" data-id="element-222" data-mp="380l2ew869ilu">
                  Bids & Tenders
                </Link>
              </li>
              <li data-id="element-223" data-mp="1inr3xpcfqsie">
                <Link to="/procurement/annual-plan" className="hover:text-au-gold transition-colors" data-id="element-224" data-mp="1in7xp5w5dsk7">
                  Annual Plan
                </Link>
              </li>
              <li data-id="element-225" data-mp="13jof4yq5uhbl">
                <Link to="/procurement/contract-awards" className="hover:text-au-gold transition-colors" data-id="element-226" data-mp="13k7rlzx1kdi8">
                  Contract Awards
                </Link>
              </li>
              <li data-id="element-227" data-mp="ptcgsi2zfmc0">
                <Link to="/procurement/supplier-registration" className="hover:text-au-gold transition-colors" data-id="element-228" data-mp="ptupie6tzt0t">
                  Expression of Interest (EOI)
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-229" data-mp="bta4dbdg1l45">
            <h3 className="font-bold text-lg mb-4" data-id="element-230" data-mp="bt1t1nwyynv2">Resources</h3>
            <ul className="space-y-2" data-id="element-231" data-mp="bveguhpersg1">
              <li data-id="element-232" data-mp="6v8o0y7ejzwd">
                <Link to="/projects" className="hover:text-au-gold transition-colors" data-id="element-233" data-mp="6vs223txm454">
                  Projects
                </Link>
              </li>
              <li data-id="element-234" data-mp="21914xcrz2ree">
                <Link to="/procurement/manual" className="hover:text-au-gold transition-colors" data-id="element-235" data-mp="216ewzc1669vn">
                  Procurement Manual
                </Link>
              </li>
              <li data-id="element-236" data-mp="2ii2f4hz68fgd">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-237" data-mp="2ihk7yqaz0gto">
                  Publications
                </a>
              </li>
              <li data-id="element-238" data-mp="2nizrgdxi2f9y">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-239" data-mp="1pt4wueuyminm">
                  Media Centre
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-240" data-mp="1uuc50f10ljut">
            <h3 className="font-bold text-lg mb-4" data-id="element-241" data-mp="1zrcaootyckle">Contact</h3>
            <p className="mb-2" data-id="element-242" data-mp="1zprhb2jdj7p4">African Union Commission</p>
            <p className="mb-2" data-id="element-243" data-mp="23tfp9mbx45aw">London Office, United Kingdom</p>
            <p className="mb-2" data-id="element-244" data-mp="23ql41sl2yggf">info@aucommission.org</p>
            <p data-id="element-245" data-mp="3b5prxau7a1sg">+44 (0) 20 4571 0123 (Procurement)</p>
            <p data-id="element-246" data-mp="3f82wvx14hvo6">+44 (0) 20 4571 1964</p>
          </div>
        </div>

        <div className="border-t border-au-green pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-247" data-mp="3f69rsm65rjia">
          <div className="flex items-center gap-4" data-id="element-248" data-mp="3dsqs07b6x1i9">
            <a href="#" className="hover:text-au-gold transition-colors" data-id="element-249" data-mp="38svzjzbro3v3">
              <TwitterIcon size={20} data-id="element-250" data-mp="3npmt3ryrelcs" />
            </a>
            <a href="#" className="hover:text-au-gold transition-colors" data-id="element-251" data-mp="3nn0l5r7yi3u1">
              <LinkedinIcon size={20} data-id="element-252" data-mp="3ip7iv99rxtz1" />
            </a>
            <a href="#" className="hover:text-au-gold transition-colors" data-id="element-253" data-mp="k46r4le4hp4">
              <FacebookIcon size={20} data-id="element-254" data-mp="ib21uuc87jr" />
            </a>
            <a href="#" className="hover:text-au-gold transition-colors" data-id="element-255" data-mp="3rpnj89v80kzo">
              <YoutubeIcon size={20} data-id="element-256" data-mp="aaqgwjac8g0f" />
            </a>
          </div>
          <p className="text-sm text-gray-300" data-id="element-257" data-mp="ac1kahzvflr0">
            © 2026 African Union. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}